import type { ChampionshipTableRowDto } from 'modules/client/tournaments/domain/types/dtos';

function extractTeamStats(
  row: Pick<
    ChampionshipTableRowDto,
    | 'gamesWon'
    | 'gamesDraw'
    | 'gamesLost'
    | 'goalsWon'
    | 'goalsLost'
    | 'championshipScore'
    | 'position'
    | 'gamesPlayed'
    | 'lastGamesResults'
  >,
) {
  return {
    won: row.gamesWon,
    drawn: row.gamesDraw,
    lost: row.gamesLost,
    goalsFor: row.goalsWon,
    goalsAgainst: row.goalsLost,
    goalDifference: row.goalsWon - row.goalsLost,
    points: row.championshipScore,
    position: row.position,
    played: row.gamesPlayed,
    form: row.lastGamesResults.map((result) => result.result[0] as 'W' | 'L' | 'D'),
  };
}

export default extractTeamStats;
